<template>
    <vx-card title="Lexi Mobile Apps">
        <h4>Lexi for iPhone</h4>
        <p class="font-medium md:w-1/2 lg:w-1/2">
          The Lexi iPhone App allows you the flexibility of accessing the most important
          aspects of your practice while you are on the go. This includes matters,
          documents, tasks, calendars, and client data.
        </p>
        <a-button type="primary">
          install
        </a-button>
        <a-divider/>
        <h4>Lexi for Android</h4>
        <p class="font-medium md:w-1/2 lg:w-1/2">
          The Lexi Android App allows you the flexibility of accessing the most important
          aspects of your practice while you are on the go. This includes matters, tasks,
          time, expense, calendars, and client data.
        </p>
        <a-button type="primary">
          install
        </a-button>
        <a-divider/>
        <h4>Lexi for iPad</h4>
        <p class="font-medium md:w-1/2 lg:w-1/2">
          The Lexi iPad App allows you the flexibility of accessing the most important
          aspects of your practice while you are on the go. This includes matters
          , documents, tasks, calendars, and client data.
        </p>
        <a-button type="primary">
          install
        </a-button>
    </vx-card>
</template>

<script>
    export default {
        name: "Apps"
    }
</script>

<style scoped>

</style>
